import { render, staticRenderFns } from "./lk-course-head.vue?vue&type=template&id=13a5f7d2&"
import script from "./lk-course-head.vue?vue&type=script&lang=js&"
export * from "./lk-course-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-course/lk-course-head/lk-course-head.vue
// module id = 1496
// module chunks = 0